<template>
    <div>
        <div class="card" style="height: 36.1vh;">
            <h2 class="card-title"><span>👤</span> Customer Info</h2>

            <div class="customer-details">
                <div class="customer-avatar">
                    <img
                        class="customer-avatar"
                        v-lazy="{
                            src: photo(customer),
                            error: onError(customer),
                            loading: require('@/assets/Rolling-1s-200px.svg'),
                            preLoad: 1.3,
                            attempt: 1
                        }"
                    />
                </div>
                <div class="customer-name">
                    {{ customer ? customer.customer_name_en : "-" }}
                </div>
                <div class="customer-id">
                    ID: {{ customer ? customer.customer_code : "-" }}
                </div>

                <div class="customer-contact">
                    <div class="contact-item">
                        <span>{{ $t("loanDisbursement.contactNo") }}:</span>
                        <span>{{ customer ? customer.contact_no : "-" }}</span>
                    </div>
                    <div class="contact-item">
                        <span>{{ $t("loanDisbursement.address") }}:</span>
                        <span
                            ><small>
                                {{
                                    customer
                                        ? customer.village
                                            ? customer.village.name_en + ", "
                                            : ""
                                        : ""
                                }}
                                {{
                                    customer
                                        ? customer.commune
                                            ? customer.commune.name_en + ", "
                                            : ""
                                        : ""
                                }}
                                {{
                                    customer
                                        ? customer.district
                                            ? customer.district.name_en + ", "
                                            : ""
                                        : ""
                                }}
                                {{
                                    customer
                                        ? customer.province
                                            ? customer.province.name_en + "."
                                            : "-"
                                        : "-"
                                }}
                            </small></span
                        >
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { Errors } from "form-backend-validation";

export default {
    name: "customerInfo",
    props: ["value"],
    data() {
        return {
            model: {},
            errors: new Errors()
        };
    },
    created() {
        this.model = this.value;
    },
    computed: {
        customer() {
            return this.$store.state.creditOperation.loanDisbursement.customers.find(
                c => c.customer_id == this.model.customer_id
            );
        }
    },
    methods: {
        photo(record) {
            if (record) {
                return record.photo;
            }

            return require("@/assets/staff-default-man.png");
        },
        onError(record) {
            if (record) {
                return record.gender == "Male"
                    ? require("@/assets/staff-default-man.png")
                    : require("@/assets/staff-default-women.png");
            }

            return require("@/assets/staff-default-man.png");
        }
    }
};
</script>
<style scoped>
.card {
    background: rgba(255, 255, 255, 0.95);
    border-radius: 20px;
    padding: 15px;
    backdrop-filter: blur(20px);
    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
    border: 1px solid rgba(255, 255, 255, 0.2);
}

.card-title {
    font-size: 20px;
    font-weight: 600;
    margin-bottom: 10px;
    color: #333;
}
/* Customer Info */
.customer-avatar {
    width: 80px;
    height: 80px;
    border-radius: 50%;
    background: linear-gradient(135deg, #667eea, #764ba2);
    display: flex;
    align-items: center;
    justify-content: center;
    color: white;
    font-size: 32px;
    font-weight: 600;
    margin: 0 auto;
}

.customer-details {
    text-align: center;
}

.customer-name {
    font-size: 18px;
    font-weight: 600;
    margin-bottom: 8px;
}

.customer-id {
    color: #666;
    font-size: 14px;
    margin-bottom: 16px;
}

.customer-contact {
    background: #f8fafc;
    padding: 16px;
    border-radius: 12px;
    margin-top: 16px;
}

.contact-item {
    display: flex;
    justify-content: space-between;
    margin-bottom: 8px;
    font-size: 14px;
}
</style>
